export default __webpack_public_path__ + "static/media/folder-open.cb2d377e.svg";